import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import { isEmpty } from 'lodash';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

import { getAppointmentsByUuid } from 'api/appointment';
import CancelBooking from './CancelBooking';
import Confirmation from '../AppointmentScheduler/Confirmation';

const Page = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%; ;
`;

const AppointmentCancel = () => {
  const location = useLocation();
  const [step, setStep] = useState('details');
  const [appointment, setAppointment] = useState();

  const parsedParams = queryString.parse(location.search);
  const linkId = parsedParams.id;

  useEffect(async () => {
    try {
      const { data } = await getAppointmentsByUuid(linkId);

      setAppointment(data.data);
    } catch (error) {
      setAppointment({});
      console.error(error);
    }
  }, []);

  if (!appointment) {
    return null;
  }

  if (isEmpty(appointment)) {
    return (
      <Page>
        <Confirmation
          heading="Appointment not found"
          description="Please contact your employer for further details."
          isError
        />
      </Page>
    );
  }

  return (
    <Page>
      {step === 'details' && (
        <CancelBooking
          appointment={appointment}
          setStep={setStep}
          linkId={linkId}
        />
      )}

      {step === 'cancel-confirm' && (
        <Confirmation
          heading="Thank you for using Global Health Solutions"
          description="Your appointment has been successfully cancelled"
        />
      )}

      {step === 'error' && (
        <Confirmation
          heading="We're Sorry"
          isError
          description="An error occurred during your submission. Please try again later."
        />
      )}
    </Page>
  );
};

export default AppointmentCancel;
